import React from 'react';
import { useMutation } from '@apollo/client';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PersonIcon from '@material-ui/icons/Person';
import Switch from '@material-ui/core/Switch';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import { GET_USERS, TOGGLE_USER_DISABLED } from '../gql/users';

const UsersItem = ({ user }) => {
  const [toggleDisabled] = useMutation(TOGGLE_USER_DISABLED, {
    refetchQueries: [{ query: GET_USERS }],
  });
  const { id, netId, role, disabled } = user;
  const matches = useMediaQuery('(min-width:600px)');

  const handleSwitchToggle = () => {
    toggleDisabled({ variables: { id, input: { disabled: !disabled } } });
  };

  return (
    <ListItem button component={NavLink} to={`/users/${id}`}>
      <ListItemIcon>
        <PersonIcon />
      </ListItemIcon>
      <ListItemText primary={netId} secondary={role} />
      <ListItemSecondaryAction>
        <Switch
          checked={!disabled}
          onChange={handleSwitchToggle}
          color="primary"
          size={matches ? 'medium' : 'small'}
        />
      </ListItemSecondaryAction>
    </ListItem>
  );
};

UsersItem.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    netId: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
    role: PropTypes.string.isRequired,
  }).isRequired,
};

export default UsersItem;
